import React, { useState, useEffect, useRef } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDInput from "components/MDInput";
import TextField from '@mui/material/TextField';
import MDButton from "components/MDButton";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select'
import axios from "axios";
import { CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import MDBox from "components/MDBox";
import MDEditor from "components/MDEditor";
import FormField from "layouts/pages/account/components/FormField";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import MapSelect from './map';
import { Grid, FormControlLabel } from '@mui/material';
import Switch from '@mui/material/Switch';
import config from "../../../config";
import MDSnackbar from "components/MDSnackbar";
import { Navigate } from 'react-router-dom';
import { useNavigate,useLocation } from "react-router-dom";

const Accidents = () => {
      const navigate = useNavigate();
  const [type, setType] = useState('');
  const [severity, setSeverity] = useState('');
  const [weather, setWeather] = useState('');
  const [roadStatus, setRoadStatus] = useState('');
  const [description, setDescription] = useState('');
  const [tseoi, setTseoi] = useState('');
  const [timerange, setTimeRange] = useState('');
  const [cluster, setCluster] = useState('');
  const [involved, setInvolved] = useState(0);
  const [position, setPosition] = useState(null); // [lon, lat]
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef(null);

 const [island, setIsland] = useState('');

  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
  const API_URL = config.MAP_MATCHING_API_URL;

  // ---- Batch CSV upload ----
  const [batchDialogOpen, setBatchDialogOpen] = useState(false);
  const [selectedCsvFile, setSelectedCsvFile] = useState(null);
  const [csvInfoMsg, setCsvInfoMsg] = useState("");
  const [csvErrors, setCsvErrors] = useState([]);
  const [csvWarnings, setCsvWarnings] = useState([]);
  const [uploadingBatch, setUploadingBatch] = useState(false);

  const canSubmitBatch = !!selectedCsvFile && csvErrors.length === 0 && !uploadingBatch;

  function bringSuccessNotification() {
    return (
      <MDSnackbar
        color="success"
        icon="check"
        title="Ατυχήματα Ειδοποίηση"
        content="Επιτυχής εγγραφή ατυχήματος"
        dateTime={new Date().toLocaleTimeString()}
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
    );
  }

  function bringErrorNotification() {
    return (
      <MDSnackbar
        color="error"
        icon="warning"
        title="Ατυχήματα Ειδοποίηση"
        content="Αποτυχία εγγραφής ατυχήματος"
        dateTime={new Date().toLocaleTimeString()}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    );
  }

  const islandTypes = [
    { id: 1, name: "Ρόδος" },
    { id: 2, name: "Κως" },
    { id: 3, name: "Κάλυμνος" },
    { id: 4, name: "Λέρος" },
    { id: 5, name: "Κάρπαθος" },
    { id: 6, name: "Κάσος" },
    { id: 7, name: "Πάτμος" },
    { id: 8, name: "Αστυπάλαια" },
    { id: 9, name: "Νίσυρος" },
    { id: 10, name: "Τήλος" },
    { id: 11, name: "Σύμη" },
    { id: 12, name: "Χάλκη" },
    { id: 13, name: "Λειψοί" },
    { id: 14, name: "Μεγίστη" },
    { id: 15, name: "Αγαθονήσι" },
    { id: 16, name: "Σύρος" }
  ];

  const accidentTypes = [
    { id: 1, name: "Σύγκρουση σε προπορευόμενο όχημα" },
    { id: 2, name: "Μετωπική σύγκρουση" },
    { id: 3, name: "Πλαγιομετωπική σύγκρουση" },
    { id: 4, name: "Πλάγια σύγκρουση" },
    { id: 5, name: "Πρόσκρουση σε σταθμευμένο όχημα" },
    { id: 6, name: "Εκτροπή οχήματος" },
    { id: 7, name: "Ανατροπή οχήματος" },
    { id: 8, name: "Παράσυρση πεζού" },
    { id: 9, name: "Σύγκρουση με ζώο" },
    { id: 10, name: "Άλλο" }
  ];

  const severityVals = [
    { id: 1, name: "Χαμηλή" },
    { id: 2, name: "Μέτρια" },
    { id: 3, name: "Υψηλή" }
  ];

  const weatherVals = [
    { id: 1, name: "Χωρίς ιδιαίτερες καιρικές συνθήκες" },
    { id: 2, name: "Βροχή" },
    { id: 3, name: "Καταιγίδα" },
    { id: 4, name: "Χαλάζι" },
    { id: 5, name: "Χιονόπτωση" },
    { id: 6, name: "Ομίχλη" },
    { id: 7, name: "Άλλο" }
  ];

  const roadStatusVals = [
    { id: 1, name: "Στεγνό" },
    { id: 2, name: "Υγρό" },
    { id: 3, name: "Λάδια" },
    { id: 4, name: "Χαλίκι" },
    { id: 5, name: "Πάγος" },
    { id: 6, name: "Γλίτσα" },
    { id: 7, name: "Άλλο" }
  ];

  const vehicleTypes = [
    { id: 1, name: "Βαρέα οχήματα & Επαγγελματικά οχήματα > 3,5 τ " },
    { id: 2, name: "Δίκυκλα" },
    { id: 3, name: "Ενοικιαζόμενα" },
    { id: 4, name: "Επαγγελματικά επιβατικά & Επαγγελματικά οχήματα < 3,5 τ " },
    { id: 5, name: "Ποδήλατα" },
    { id: 6, name: "Πεζοί" },
    { id: 7, name: "Ηλεκτρικά πατίνια" },
    { id: 8, name: "Επιβατικό Ι.Χ." },
    { id: 9, name: "Λοιπά οχήματα" }
  ];

  const violationLabels = [
    { id: 1, name: "Διαπιστωμένη υπέρβαση του ορίου ταχύτητας" },
    { id: 2, name: "Αριστερή στροφή σε διπλή διαχωριστική γραμμή" },
    { id: 3, name: "Παραβίαση STOP/Φωτ. σηματοδότη" },
    { id: 4, name: "Παράνομη στάθμευση" },
    { id: 5, name: "Αντικανονικό προσπέρασμα" },
    { id: 6, name: "Επικίνδυνοι ελιγμοί" },
    { id: 7, name: "Παραβίαση προτεραιότητας σε κόμβο" },
    { id: 10, name: "Οδήγηση χωρίς τη νόμιμη άδεια οδήγησης" },
    { id: 9, name: "Οδήγηση υπό την επίδραση αλκοόλ" },
    { id: 8, name: "Παράνομη αναστροφή" }
  ];

  const injuredTypes = [
    { id: 1, name: "Ελαφρά τραυματίες" },
    { id: 2, name: "Βαριά τραυματίες" },
    { id: 3, name: "Νεκροί" }
  ];

  const handleInputChange = (field, value) => {
    if (field === "type_accident") {
      setType(value.id);
    } else if (field === 'island') {
        setIsland(value?.id || "");
    } else if (field === 'weather') {
      setWeather(value.id);
    } else if (field === 'road') {
      setRoadStatus(value.id);
    } else if (field === 'involved') {
      setInvolved(value.id);
    } else if (field === 'tseoi') {
      setTseoi(value.target.value);
    } else if (field === "description") {
      requestAnimationFrame(() => {
        setDescription(value);
      });
    } else {
      console.error("Unknown field: ", field);
    }
  };

  const [selectedCounts, setSelectedCounts] = useState({});
  const [selectedInjured, setSelectedInjured] = useState({});
  const [selectedViolations, setSelectedViolations] = useState({});

  const handleChange = (vehicleId, value) => {
    setSelectedCounts(prev => ({
      ...prev,
      [vehicleId]: value === '' ? '' : Math.max(0, parseInt(value) || 0)
    }));
  };

  const handleChangeInjured = (id, value) => {
    setSelectedInjured(prev => ({
      ...prev,
      [id]: value === '' ? '' : Math.max(0, parseInt(value) || 0)
    }));
  };

  const handleViolationChange = (label, value) => {
    setSelectedViolations(prev => ({
      ...prev,
      [label]: value,
    }));
  };

  const handleDateChange = (date, field) => {
    if (date && date[0]) {
      setTimeRange(date[0].toISOString());
    }
  };

  // ----- CSV helpers -----
  const CSV_HEADER = [
    "island", "type_accident", "weather", "road", "date", "longitude", "latitude", "police_report", "description",
    "involved_1", "involved_2", "involved_3", "involved_4", "involved_5", "involved_6", "involved_7", "involved_8", "involved_9",
    "injured_1", "injured_2", "injured_3",
    "violation_1", "violation_2", "violation_3", "violation_4", "violation_5", "violation_6", "violation_7", "violation_8", "violation_9", "violation_10",
    "severity"
  ];

  // Parses a single CSV line, handling quotes
  const parseCsvLine = (line) => {
    const result = [];
    let current = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        if (inQuotes && line[i + 1] === '"') {
          // Escaped quote
          current += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        result.push(current);
        current = "";
      } else {
        current += char;
      }
    }
    result.push(current);
    return result;
  };

  // ---- CSV IMPORT (Εισαγωγή CSV) ----
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Reset dialog state
    setSelectedCsvFile(file);
    setFileName(file.name);
    setCsvErrors([]);
    setCsvWarnings([]);
    setCsvInfoMsg(
      `Επιλέξατε το αρχείο: ${file.name}. Ελέγξτε τα μηνύματα και πατήστε Υποβολή για αποστολή.`
    );
    setBatchDialogOpen(true);

    const errors = [];
    const warnings = [];

    const addError = (msg) => errors.push(msg);
    const addWarn = (msg) => warnings.push(msg);

    // Basic check
    if (!file.name.toLowerCase().endsWith(".csv")) {
      addError("Το αρχείο πρέπει να είναι .csv");
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const text = e.target.result;
        const lines = text
          .split("\n")
          .map((l) => l.trim())
          .filter((l) => l.length > 0);

        if (lines.length < 2) {
          addError("Το CSV πρέπει να περιέχει header row και τουλάχιστον 1 γραμμή δεδομένων.");
        } else {
          const headerLine = lines[0];
          const dataLine = lines[1];

          const headerCols = parseCsvLine(headerLine);
          const values = parseCsvLine(dataLine).map((v) => v.trim());

          if (headerCols.length !== CSV_HEADER.length) {
            addWarn(
              "Ο αριθμός στηλών του header δεν ταιριάζει με το template. Θα γίνει αντιστοίχιση με βάση τη σειρά (index)."
            );
          }


        }
      } catch (err) {
        addError(`Σφάλμα ανάγνωσης CSV: ${err?.message || String(err)}`);
      } finally {
        setCsvErrors(errors);
        setCsvWarnings(warnings);
      }
    };

    reader.onerror = () => {
      setCsvErrors(["Αποτυχία ανάγνωσης του αρχείου CSV."]);
      setCsvWarnings([]);
    };

    reader.readAsText(file);
  };

  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleCloseBatchDialog = () => {
    setBatchDialogOpen(false);
    setUploadingBatch(false);

    // Allow re-selecting the same file to trigger onChange again
    if (fileInputRef.current) fileInputRef.current.value = "";

      window.location.reload();
  };

  const handleSubmitBatchUpload = async () => {
    if (!selectedCsvFile || csvErrors.length > 0) return;

    setUploadingBatch(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedCsvFile);
       const url = `${API_URL}/accidents/batch`;
      await axios.post(url, formData, {
        headers: {
          accept: "*/*",
          "X-API-Key": API_TOKEN,
          "Content-Type": "multipart/form-data",
        },
      });

      openSuccessSB();
      setBatchDialogOpen(false);
      setTimeout(() => {
      navigate('/list/accidents');
      }, 3000);
    } catch (error) {
      console.log(error);
      openErrorSB();
    } finally {
      setUploadingBatch(false);
    }
  };

  // ---- CSV DOWNLOAD (Κατέβασμα φόρμα csv) ----
  const handleDownloadTemplate = () => {
    const header = CSV_HEADER.join(",");
    const csvContent = header + "\n"; // only header; user will add rows

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "accident_form_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  function transformAccidentData(data) {
    return {
      ...data,
      involved: Object.entries(data.involved || {}).map(([id, value]) => ({ id: Number(id), value })),
      injured: Object.entries(data.injured || {}).map(([id, value]) => ({ id: Number(id), value })),
      violations: Object.entries(data.violations || {})
        .filter(([_, isTrue]) => isTrue)
        .map(([id]) => Number(id))
    };
  }

  const handleSubmit = async () => {
    console.log(island, type, weather, roadStatus, description, timerange, position, selectedCounts, selectedViolations, selectedInjured);
    var reserveposition = position ? [position[1],position[0]] : null;
    const data = {
      id: 0,
      island: island,
      type_accident: type,
      weather: weather,
      road: roadStatus,
      description: description,
      date: timerange,
      position: reserveposition,
      involved: selectedCounts,
      violations: selectedViolations,
      injured: selectedInjured,
      severity: 1,
      police_report: tseoi
    };

    const dataToSend = transformAccidentData(data);
    console.log("Data to send:", dataToSend);
    console.log(JSON.stringify(dataToSend, null, 2));
    try {
      const url = `${API_URL}/accidents`;

      await axios.post(url, dataToSend, {
        headers: {
          'X-API-Key': API_TOKEN,
          'Content-Type': 'application/json'
        }
      });
      setSuccessSB(true);
      setTimeout(() => {
        navigate('/list/accidents');
      }, 3000);
    } catch (error) {
      console.log(error);
      setErrorSB(true);
    }
  };

  // ---- JSX (unchanged except CSV buttons) ----
  return (
    <DashboardLayout>
      <MDBox mt={4} p={0}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={5}>
            <Card id="accident-form" sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5">Εισαγωγή Ιστορικό Ατυχημάτων</MDTypography>
              </MDBox>
              <MDBox compoent="form" pb={3} px={3}>
                <Grid container spacing={3}>
                  {/* Island */}
                  <Grid item xs={12}>
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Νησί στο οποίο έγινε το ατύχημα *
                    </MDTypography>

                    <Autocomplete
                    value={islandTypes.find((i) => i.id === island) || null}
                    options={islandTypes}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, selectedOption) => handleInputChange("island", selectedOption)}
                    renderInput={(params) => <MDInput {...params} variant="standard" />}
                    />
                  </Grid>

                  {/* Date */}
                  <Grid item xs={12} sm={6} container direction="column">
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Ημερομηνία *
                    </MDTypography>
                    <MDDatePicker
                      input={{ placeholder: "dd/mm/yyyy HH:mm" }}
                      value={timerange ? new Date(timerange) : null}
                      options={{
                        enableTime: true,
                        dateFormat: "d/m/Y H:i",
                        altFormat: "d/m/Y H:i",
                        time_24hr: true,
                      }}
                      onChange={(date) => handleDateChange(date, "date")}
                    />
                  </Grid>

                  {/* Position */}
                  <Grid item xs={12} sm={12} container direction="column">
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Θέση Ατυχήματος *
                    </MDTypography>
                    {!position && (
                      <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                        Επέλεξε Θέση στο Χάρτη
                      </MDTypography>
                    )}
                    {position && (
                      <>
                        <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                          Lat: {position[1]}
                        </MDTypography>
                        <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                          Long: {position[0]}
                        </MDTypography>
                      </>
                    )}

                  </Grid>

                  {/* Type of Accident */}
                  <Grid item xs={12}>
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Κατηγορία Ατυχήματος *
                    </MDTypography>
                    <Autocomplete
                      value={accidentTypes.find(vl => vl.id === type) || null}
                      options={accidentTypes}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) => handleInputChange("type_accident", selectedOption)}
                      renderInput={(params) => <MDInput {...params} variant="standard" />}
                    />
                  </Grid>

                  {/* Weather */}
                  <Grid item xs={12}>
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Κατάσταση Καιρού *
                    </MDTypography>
                    <Autocomplete
                      value={weatherVals.find(item => item.id === weather) || null}
                      options={weatherVals}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) => handleInputChange("weather", selectedOption)}
                      renderInput={(params) => <MDInput {...params} variant="standard" />}
                    />
                  </Grid>

                  {/* Road status */}
                  <Grid item xs={12}>
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Κατάσταση Δρόμου *
                    </MDTypography>
                    <Autocomplete
                      value={roadStatusVals.find(val => val.id === roadStatus) || null}
                      options={roadStatusVals}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) => handleInputChange("road", selectedOption)}
                      renderInput={(params) => <MDInput {...params} variant="standard" />}
                    />
                  </Grid>

                  {/* Involved */}
                  <Grid item xs={12}>
                    <MDBox mb={1}>
                      <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                        Καταχωρήστε το πλήθος των εμπλεκόμενων *
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      display="grid"
                      gridTemplateColumns={{ xs: "1fr" }}
                      gap={2}
                    >
                      {vehicleTypes.map(vehicle => (
                        <MDBox key={vehicle.id} sx={{ minWidth: 170 }}>
                          <MDInput
                            type="number"
                            label={vehicle.name}
                            variant="standard"
                            value={selectedCounts[vehicle.id] || 0}
                            onChange={(e) => handleChange(vehicle.id, e.target.value)}
                            fullWidth
                            inputProps={{ min: 0 }}
                          />
                        </MDBox>
                      ))}
                    </MDBox>
                  </Grid>

                  {/* Violations */}
                  <Grid item xs={12}>
                    <MDBox mb={1}>
                      <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                        Αίτια Ατυχήματος *
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      display="grid"
                      gridTemplateColumns={{ xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
                      gap={2}
                    >
                      {violationLabels.map((violation) => (
                        <MDBox
                          key={violation.id}
                          sx={{
                            minWidth: 170,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            boxShadow: 2,
                            borderRadius: 2,
                          }}
                        >
                          <MDTypography variant="button" fontWeight="regular" sx={{ mb: 1, textAlign: "center" }}>
                            {violation.name}
                          </MDTypography>
                          <Switch
                            checked={!!selectedViolations[violation.id]}
                            onChange={(e) => handleViolationChange(violation.id, e.target.checked)}
                          />
                        </MDBox>
                      ))}
                    </MDBox>
                  </Grid>

                  {/* Injured */}
                  <Grid item xs={12}>
                    <MDBox mb={1}>
                      <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                        Καταχωρήστε το πλήθος των παθόντων *
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      display="grid"
                      gridTemplateColumns={{ xs: "1fr", lg: "repeat(3, 1fr)" }}
                      gap={2}
                    >
                      {injuredTypes.map(item => (
                        <MDBox key={item.id} sx={{ minWidth: 170 }}>
                          <MDInput
                            type="number"
                            label={item.name}
                            variant="standard"
                            value={selectedInjured[item.id] || 0}
                            onChange={(e) => handleChangeInjured(item.id, e.target.value)}
                            fullWidth
                            inputProps={{ min: 0 }}
                          />
                        </MDBox>
                      ))}
                    </MDBox>
                  </Grid>

                  {/* TSEOI */}
                  <Grid item xs={12}>
                    <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                        Αναγνωριστικός Αριθμός Τροχαίας
                      </MDTypography>
                    </MDBox>
                    <MDInput
                      fullWidth
                      type="text"
                      value={tseoi || ""}
                      onChange={(e) => handleInputChange("tseoi", e)}
                    />
                  </Grid>

                  {/* Description */}
                  <Grid item xs={12}>
                    <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                        Σύντομη Περιγραφή/Παρατηρήσεις
                      </MDTypography>
                    </MDBox>
                    <MDEditor
                      value={description || ""}
                      onChange={(e) => handleInputChange("description", e)}
                    />
                  </Grid>

                  {/* Submit + CSV buttons */}
                  <Grid mt={3} item xs={12}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <input
                          type="file"
                          accept=".csv"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <MDButton
                          variant="contained"
                          color="warning"
                          onClick={handleImportClick}
                          sx={{ "&.MuiButton-contained": { textTransform: "capitalize !important" } }}
                        >
                          Εισαγωγή CSV
                        </MDButton>

                        <MDButton
                          variant="outlined"
                          color="info"
                          onClick={handleDownloadTemplate}
                          sx={{ "&.MuiButton-outlined": { textTransform: "capitalize !important" } }}
                        >
                          Κατέβασμα φόρμα csv
                        </MDButton>

                        <span style={{ marginLeft: "10px" }}>{fileName}</span>
                      </MDBox>

                      {(island !== '' && position !== null) ? (
                        <MDButton
                          variant="gradient"
                          color="info"
                          onClick={handleSubmit}
                          sx={{ "&.MuiButton-contained": { textTransform: "capitalize !important" } }}
                        >
                          Καταχώρηση
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="gradient"
                          color="info"
                          onClick={handleSubmit}
                          disabled
                          sx={{ "&.MuiButton-contained": { textTransform: "capitalize !important" } }}
                        >
                          Καταχώρηση
                        </MDButton>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} md={7}>
            <div className="mapContainer100">
              <MapSelect selectedPoint={position} setSelectedPoint={setPosition} />
            </div>
          </Grid>

          {/* Batch CSV Upload Dialog */}
          <Dialog open={batchDialogOpen} onClose={handleCloseBatchDialog} fullWidth maxWidth="sm"   
          PaperProps={{
          sx: {
            backgroundColor: "#1f2a44",   // 👈 same as table
            color: "#ffffff",
            borderRadius: 2,
            minWidth: 420,
          },
        }}>
            <DialogTitle     sx={{
      color: "#ffffff",
      borderBottom: "1px solid rgba(255,255,255,0.12)",
    }}>Αποστολή CSV (Batch)</DialogTitle>
            <DialogContent dividers>
              <Stack spacing={2}>
                {/* FIRST ROW: info message */}
                <Alert severity="info">{csvInfoMsg}</Alert>

                {csvErrors.length > 0 && (
                  <Alert severity="error">
                    <div style={{ fontWeight: 600, marginBottom: 6 }}>Βρέθηκαν σφάλματα:</div>
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {csvErrors.map((e, i) => (
                        <li key={i}>{e}</li>
                      ))}
                    </ul>
                  </Alert>
                )}

                {csvWarnings.length > 0 && (
                  <Alert severity="warning">
                    <div style={{ fontWeight: 600, marginBottom: 6 }}>Προειδοποιήσεις:</div>
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {csvWarnings.map((w, i) => (
                        <li key={i}>{w}</li>
                      ))}
                    </ul>
                  </Alert>
                )}

                {csvErrors.length === 0 && selectedCsvFile && (
                  <Alert severity="success">
                    Ο έλεγχος ολοκληρώθηκε χωρίς σφάλματα. Μπορείτε να πατήσετε Υποβολή.
                  </Alert>
                )}
              </Stack>
            </DialogContent>

            <DialogActions 
                sx={{
                borderTop: "1px solid rgba(255,255,255,0.12)",
                px: 3,
                py: 2,
                }}>
              <MDButton
                variant="outlined"
                color="secondary"
                onClick={handleCloseBatchDialog}
                disabled={uploadingBatch}
                sx={{ "&.MuiButton-outlined": { textTransform: "capitalize !important" },        color: "#ffffff",
        borderColor: "rgba(255,255,255,0.5)",
        textTransform: "none",
        "&:hover": {
          borderColor: "#ffffff",
        } }}
              >
                Ακύρωση
              </MDButton>

              <MDButton
                variant="contained"
                color="info"
                onClick={handleSubmitBatchUpload}
                disabled={!canSubmitBatch}
                sx={{ "&.MuiButton-contained": { textTransform: "capitalize !important" } }}
              >
                {uploadingBatch ? <CircularProgress size={18} /> : "Υποβολή"}
              </MDButton>
            </DialogActions>
          </Dialog>

          {successSB && bringSuccessNotification()}
          {errorSB && bringErrorNotification()}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default Accidents;
